import { Timestamp } from "firebase/firestore";
import { BaseFirestore } from "./Firestore";
import { Employee } from "./Employee";
import { Card } from "./Card";

export const TaskType = {
  GENERAL: "general",
  UPDATE: "update",
  PARTS: "parts",
  OTHER: "other",
} as const;
export type TaskType = (typeof TaskType)[keyof typeof TaskType];

export type Task = BaseFirestore & {
  title: string;
  description?: string;
  assigneeId?: Employee["id"];
  assigneeAuthUid?: string;
  type: TaskType;
  relatedRO?: Card["id"];
  dueDate?: Date | Timestamp;
  completed: boolean;
  isPrivate: boolean;
  /** Same denormalized-count convention as Card["attachmentCount"]. */
  attachmentCount?: number;
};
